import React from "react";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import { DeleteDialogSection } from "./DeleteDialogSection";
import { SearchBar } from "components/common/SearchBar";
import { Spinner } from "components/common/Spinner";
interface TransferSectionProps {
  isActive: boolean;
  filterQuery: string;
  setFilterQuery: (query: string) => void;
  transferSectionRef: (node: HTMLElement | null) => void;
  title?: string;
  filterPlaceholder?: string;
  filterType?: "email" | "search";
  loading?: boolean;
  emptyMessage?: string;
  onSubmit?: () => void;
  submitLoading?: boolean;
  errorMessage?: string;
  children: React.ReactNode;
}

export const TransferSection: React.FC<TransferSectionProps> = ({
  isActive,
  filterQuery,
  setFilterQuery,
  transferSectionRef,
  title = "Transfer Ownership",
  filterPlaceholder = "Enter email address...",
  filterType = "email",
  loading = false,
  emptyMessage = "No targets available for transfer",
  onSubmit,
  submitLoading = false,
  errorMessage,
  children,
}) => (
  <DeleteDialogSection
    icon={<SendOutlinedIcon className="icon-sm text-fg-muted-regular" />}
    title={title}
    isActive={isActive}
    className="h-full min-h-0 p-4"
    headerContent={
      <div className="flex flex-col gap-1">
        {filterType === "email" ? (
          <div className="relative">
            <input
              type="email"
              value={filterQuery}
              onChange={(e) => setFilterQuery(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" && onSubmit) {
                  e.preventDefault();
                  onSubmit();
                }
              }}
              placeholder={filterPlaceholder}
              className="w-full px-3 py-1.5 text-sm rounded-app border border-border bg-transparent text-fg-regular placeholder:text-fg-muted outline-none focus:border-accent transition-colors"
            />
            {submitLoading && (
              <div className="absolute right-2 top-1/2 -translate-y-1/2">
                <div className="animate-spin rounded-full icon-xs border-2 border-accent/30 border-t-accent/50" />
              </div>
            )}
          </div>
        ) : (
          <SearchBar
            value={filterQuery}
            onChange={setFilterQuery}
            placeholder={filterPlaceholder}
          />
        )}
        {errorMessage && (
          <span className="text-error text-xs px-1">{errorMessage}</span>
        )}
      </div>
    }
  >
    <div ref={transferSectionRef} className="min-h-12.5">
      {loading ? (
        <div className="flex justify-center py-8">
          <Spinner />
        </div>
      ) : (
        (children ?? (
          <div className="text-fg-muted-regular py-4 text-center">
            {emptyMessage}
          </div>
        ))
      )}
    </div>
  </DeleteDialogSection>
);
